import { Typography, withStyles } from '@material-ui/core';
import React from 'react'
import { compose } from 'recompose';
import withErrorCatcher from '../Common/withErrorCatcher';
import { connect } from 'react-redux';
import HashHeaderIcon from '../Common/Icons/ChannelIcons/hashHeaderIcon';

const styles = theme => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    title: {
        fontFamily: 'Rubik',
        fontSize: 18,
        lineHeight: 0.67,
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        letterSpacing: 'normal',
        color: theme.newUI.color.commonBlack,
        display: 'block',
        paddingTop: 16,
    },
    description: {
        marginTop: 8,
        display: 'block',
        fontFamily: 'Rubik',
        fontSize: 11,
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.43,
        letterSpacing: '0.4px',
        color: theme.newUI.color.gray,
    },
    subtitle: {
        marginTop: 8,
        display: 'block',
        fontFamily: 'Rubik',
        fontSize: 11,
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.43,
        letterSpacing: '0.4px',
        color: theme.newUI.color.gray,
    },
    iconHolder: {
        margin: '0 auto',
    },
    iconHolderSmall: {
        marginTop: 12,
        textAlign: 'center',
    },
    icon: {
        width: 88, 
        height: 88,
        backgroundColor: '#eeeef3',
        borderRadius: '100%'
    },
    iconSmall: {
        width: 40,
        height: 40,
        backgroundColor: '#eeeef3',
        borderRadius: '100%'
    }
})
const __TagsInfoDrawer = (props) => {
    const {classes, query, isDrawerOpen, currentTagInfo} = props
    const {tagType, description} = currentTagInfo

    const showDesc = isDrawerOpen && !!description && description !== query
    return (
        <div data-intrcm-id="TagsInfoDrawer_006zcd0j" className={isDrawerOpen ? classes.container : classes.containerMinimize}>
            <div data-intrcm-id="TagsInfoDrawer_3gqn577n" className={isDrawerOpen ? classes.iconHolder : classes.iconHolderSmall}><HashHeaderIcon className={isDrawerOpen ? classes.icon : classes.iconSmall}/></div>
            {isDrawerOpen && <Typography className={classes.title}>{query}</Typography>}
            {/* {showDesc && <Typography className={classes.description}>{description}</Typography>}
            {isDrawerOpen && <Typography dir='auto' className={classes.subtitle}>{tagType === 'topic' ? 'Topic' : 'Channel'}</Typography>} */}
        </div>
    )
}

const mapStateToProps = (state) => ({
    myAuth0_id: state.userData.profileData.auth0_id,
})

export const TagsInfoDrawer = compose(
    withStyles(styles),
    withErrorCatcher("Failed loading User Info, Please Contact Tuqqi Support"),
    connect(mapStateToProps, null)
)(__TagsInfoDrawer);